import { useState } from 'react';
import { isComplete, technicianNames } from '../../data/domain';
import { useJobs, useTechnicians } from '../../data/hooks';
import { dateKey, initials, longDate, plural } from '../../lib/format';
import { Icon } from '../../ui/Icon';
import { useUI } from '../../ui/UIProvider';
import { EmptyState, PageHeading, PanelHeader, View } from '../../ui/View';

const ALL = 'All technicians';

export function RunSheetsView() {
  const jobs = useJobs();
  const technicians = useTechnicians();
  const ui = useUI();
  const query = new URLSearchParams(window.location.search);
  const [date, setDate] = useState(query.get('date') || dateKey());
  const [tech, setTech] = useState(query.get('tech') || ALL);
  const names = technicianNames(technicians, jobs);
  const daily = jobs.filter((job) => job.date === date && !job.cancelled && (tech === ALL || job.techName === tech));
  const groups = tech === ALL ? [...new Set(daily.map((job) => job.techName))].sort() : [tech];

  return (
    <View id="run-sheets">
      <PageHeading eyebrow="Field operations" title="Technician run sheets" subtitle="Select a technician to open their hour-by-hour day sheet." />
      <div className="toolbar">
        <label>Date <input id="runSheetDate" type="date" value={date} onChange={(event) => setDate(event.target.value)} /></label>
        <label>Technician
          <select id="runSheetTech" value={tech} onChange={(event) => setTech(event.target.value)}>
            {[ALL, ...new Set([...names, ...(tech !== ALL ? [tech] : [])])].map((name) => <option key={name}>{name}</option>)}
          </select>
        </label>
      </div>
      <div className="panel">
        <PanelHeader title={longDate(date)} summary={plural(daily.length, 'job') + ' scheduled'} />
        <div className="row-list" id="runSheetList">
          {groups.length ? groups.map((name) => {
            const assigned = daily.filter((job) => job.techName === name);
            const done = assigned.filter(isComplete).length;
            return (
              <button className="row row-button run-sheet-row" key={name} onClick={() => ui.open('runSheet', { tech: name, date })}>
                <span className="avatar" aria-hidden="true">{initials(name)}</span>
                <span className="row-text"><b>{name}</b><small>{plural(assigned.length, 'job')} scheduled · {done} completed</small></span>
                <span className="btn-link">Open day sheet <Icon name="arrowRight" size={16} /></span>
              </button>
            );
          }) : <EmptyState>No jobs scheduled for this day.</EmptyState>}
        </div>
      </div>
    </View>
  );
}
